import React from "react";
import Dashboard from "pages/Dashboard";
import Employee from "pages/Employee";
import Task from "pages/Task";
import Notification from "pages/Notification";
import Calendar from "pages/Calendar";
import Approval from "pages/Approval";
import AttendanceReport from "pages/AttendanceReport";
import LeaveReport from "pages/LeaveReport";
import BreakReport from "pages/BreakReport";
import OvertimeReport from "pages/OvertimeReport";
import MyProfile from "pages/my-profile";
import Team from "pages/Team";
import Chat from "pages/Chat";
import Documents from "pages/Documents";
import MyDocuments from "pages/MyDocuments";
import Location from "pages/Location";
import Department from "pages/Department";
import Trends from "pages/Trends";
import Productivity from "pages/Productivity";
import Demographics from "pages/Demographics";
import LateCheckIn from "pages/LateCheckIn";
import EarlyCheckOut from "pages/EarlyCheckOut";
import AbsendReport from "pages/AbsendReport";
import Myleavereport from "pages/Myleavereport";
import ReleasedNote from "pages/ReleasedNote";
import MonthlyAttendanceReport from "pages/MonthlyAttendanceReport";
import Roles from "pages/Roles";
import Shift from "pages/Shift";
import RolesAndPermissions from "pages/RolesAndPermissions";
import Break from "pages/Break";
import LeaveCategories from "pages/LeaveCategories";
import Holiday from "pages/holiday";
import CloseAccount from "pages/CloseAccount";
import EmployeeDetails from "organisms/EmployeeDetails";
import ManagerDashboard from "pages/ManagerDashboard";
import HrDashboard from "pages/HrDashboard";
import Permission from "pages/Permission";
import ProfileDetails from "pages/ProfileDetails";
import HRPolicy from "pages/HRPolicy";
import Band from "pages/Band/index";
import Ownerdashboard from "pages/OwnerDashboard";
import Appraisal from "pages/Appraisal";
import AddAppraisal from "pages/AddAppraisal";
import AppraisalResponse from "pages/AppraisalResponse";
import MyAppraisal from "pages/MyAppraisal";
import FormBuilder from "pages/FormBuilder";
import Recruitment from "pages/Recruitment";
import RecruitmentTab from "pages/RecruitmentTab";
import Onboarding from "pages/Onboarding/Onboarding";
import Contract from "pages/Contract";
import Addjob from "pages/AddJob";
import TemplateContract from "pages/Contract/TemplateContract";
import IssueContract from "pages/Contract/IssueContract";
import HRDocuments from "pages/HRDocuments";
import FormResponse from "pages/FormResponse";
import PendingEmployee from "pages/PendingEmployee";
import CompanyPolicy from "pages/CompanyPolicy";
import MyTeam from "pages/MyTeam";
import AddNewClient from "pages/ClientNew/addClient/AddClientParent";

import ClientNew from "pages/ClientNew";

import ClientDetails from "pages/ClientNew/ClientDetailed";
import SendFundRequestMail from "pages/ClientNew/SendFundRequestMail";
import Engagement from "pages/Engagement";
import AddNewEngagement from "pages/Engagement/AddNewEngagement";
import EngagementView from "pages/Engagement/EngagementView";
import AddResources from "pages/Engagement/EngagementView/AddResources";
import TodoView from "pages/Engagement/EngagementView/TodoList/TodoView";
import Claims from "pages/Engagement/EngagementView/Claims";
import Billing from "pages/Engagement/Billing";
import ResourcePlanning from "pages/ResourcePlanning";
import Performance from "pages/Performance";
import Assests from "pages/Assests";
import AddNewBilling from "pages/Engagement/Billing/AddNewBilling.js";
import FinancialSummary from "pages/Engagement/FinancialSummary";
import TimeSheet from "pages/TimeSheet";
import TimeSheetDetailed from "pages/TimeSheet/TimeSheetDetailed";
import ClientContact from "pages/ClientContact/ClientContact";
import ClientContactDetails from "pages/ClientContact/ClientContactDetails";
import TimeSheetHistory from "pages/TimeSheet/History";
import EngagementAppraisal from "pages/Engagement/EngagementView/EngagementAppraisal";
import ChargeoutRates from "pages/ChargeoutRates/ChargeoutRates";
import EngagementCalendar from "pages/Engagement/EngagementCalendar";
import MyDeclaration from "pages/Declaration/MyDeclaration";
import IndependenceAnalysis from "pages/IndependenceAnalysis";
import DetailView from "pages/IndependenceAnalysis/DetailView";
import WeekCalendarView from "pages/WeekCalendarView";
import TimesheetReport from "pages/TimesheetReport";
import OnboardingReport from "pages/OnboardingReport";
import Viewmytabledata from "pages/PerformanceMnagement/Viewperformance/Viewmytabledata";
import ViewDetails from "pages/PerformanceMnagement/Viewperformance/View";
import Evaluation from "pages/PerformanceMnagement/Viewperformance/Evaluation";
import NextAppraisal from "pages/PerformanceMnagement/Viewperformance/Nextappraisal";
import RoleAccountant from "pages/PerformanceMnagement/RoleAccountant";
import PerformanceManagement from "pages/PerformanceMnagement/PerformanceManagement";
import MinePerformance from "pages/PerformanceMnagement/MinePerformance";
import MyTeamPerformance from "pages/PerformanceMnagement/MyTeamPerformance";
import PerformanceContract from "pages/PerformanceMnagement/PerformanceContract";
import CreatingPerformance from "pages/PerformanceMnagement/CreatingPerformance";
import EvaluatedResponse from "pages/PerformanceMnagement/EvaluatedResponse";
import Evaluated from "pages/PerformanceMnagement/Evaluated";
import EditingAppraisal from "pages/PerformanceMnagement/EditingAppraisal";
import ReviewAgree from "pages/PerformanceMnagement/Review&Agree/Review&Agree";
import Agreed from "pages/PerformanceMnagement/Agreed/Agreed";
import Attend from "pages/PerformanceMnagement/Attendpage/Attend";
import Viewcompleted from "pages/PerformanceMnagement/Viewperformance/Viewcompleted";
import Viewpending from "pages/PerformanceMnagement/Viewperformance/Viewpending";
import JobDescription from "pages/PerformanceJobDescription/JobDescription";
import AwaitingAppraiseeRespons from "pages/PerformanceMnagement/AwaitingAppraiseeRespons";
import ViewContract from "pages/PerformanceMnagement/ViewContract";
import ChangeManager from "pages/ChangeManager/ChangeManager";
import CurrencyCreate from "pages/CurrencyCreate/index";
import EngagementCheckNew from "pages/Engagement/ThirdParty/EngagementCheckNew";
import RoleManagement from "pages/RoleManagement/RoleManagement";
import Accounts from "pages/Accounts";
import AddEditClient from "pages/ClientNew/AddEditClient";
import PendingClient from "pages/ClientNew/PendingClient";
import ClientDetail from "pages/ClientNew/ClientDetail";
import MyTask from "pages/MyTask";
import Announcement from "pages/Announcement/Announcement";
import AddEditAnnouncement from "pages/Announcement/AddEditAnnouncement";
import AnnouncementDetails from "pages/Announcement/AnnouncementDetails";
import Matter from "pages/Matter";
import Creatematter from "pages/Matter/Creatematter";
import MatterDetails from "pages/Matter/MatterDetails";
import AddResourceForMatter from "pages/Matter/AddResourceForMatter";
import FinancialSummaryMatter from "pages/Matter/FinancialSummaryMatter";
import ClientSurveyMatter from "pages/Matter/ClientSurveyMatter";
import BillingEmail from "pages/Matter/BillingEmail";
import MarkAsPaidPage from "pages/MarkAsPaidPage";
import BillingEntity from "pages/BillingEntity";
import MyIncident from "pages/IncidentManagement/MyIncident";
import ViewIncident from "pages/IncidentManagement/ViewIncident";
import Viewincidentlog from "pages/IncidentManagement/Viewincidentlog";
import IncidentLog from "pages/IncidentManagement/IncidentLog";
import HrMyDisciplinary from "pages/HrMyDisciplinary";
import HomeDisciplinary from "pages/HomeDisciplinary";
import Viewdisciplinary from "pages/HomeDisciplinary/Viewdisciplinary";
import ViewDetailsDisciplinary from "pages/HrMyDisciplinary/ViewDetailsDisciplinary";
import CategoryView from "pages/HrMyDisciplinary/CategoryView";
import CategoryTable from "pages/HrMyDisciplinary/Categorytable";
import ViewUnderReview from "pages/IncidentManagement/ViewUnderReview";
import ViewResolved from "pages/IncidentManagement/ViewResolved";
import ViewDismissed from "pages/IncidentManagement/ViewDismissed";
import EditDeletepage from "pages/IncidentManagement/EditDeletepage";


const Routes = [
  {
    path: "dashboard",
    title: "Dashboard",
    content: () => <Dashboard />,
  },
  {
    path: "employee",
    title: "Employees",
    content: () => <Employee />,
  },
  {
    path: "task",
    title: "Task",
    content: () => <Task />,
  },
  {
    path: "mytask",
    title: "My Task",
    content: () => <Task />,
  },
  {
    path: "notification",
    title: "Notification",
    content: () => <Notification />,
  },
  {
    path: "calendar",
    title: "Calendar",
    content: () => <Calendar />,
  },
  {
    path: "location",
    title: "Location",
    content: () => <Location />,
  },
  {
    path: "approvals/bills/:id",
    title: "Billing",
    content: () => <AddNewBilling />,
  },
  {
    path: "approvals",
    title: "Approval",
    content: () => <Approval />,
  },
  {
    path: "attendance-report",
    title: "Attendance Report",
    content: () => <AttendanceReport />,
  },
  {
    path: "leave-report",
    title: "Leave Report",
    content: () => <LeaveReport />,
  },
  {
    path: "break-report",
    title: "Break Report",
    content: () => <BreakReport />,
  },
  {
    path: "overtime-report",
    title: "Overtime Report",
    content: () => <OvertimeReport />,
  },
  {
    path: "my-profile",
    title: "my-profile",
    content: () => <MyProfile />,
  },
  {
    path: "team",
    title: "team",
    content: () => <Team />,
  },
  {
    path: "chat/:id",
    title: "chat",
    content: () => <Chat />,
  },
  {
    path: "documents/:id",
    title: "documents",
    content: () => <Documents />,
  },
  {
    path: "mydocuments",
    title: "my-documents",
    content: () => <MyDocuments />,
  },
  {
    path: "department",
    title: "Departments",
    content: () => <Department />,
  },
  {
    path: "trends",
    title: "Trends",
    content: () => <Trends />,
  },
  {
    path: "productivity",
    title: "Productivity",
    content: () => <Productivity />,
  },
  {
    path: "demographics",
    title: "Demographics",
    content: () => <Demographics />,
  },
  {
    path: "Late-check-in",
    title: "Late check-in",
    content: () => <LateCheckIn />,
  },
  {
    path: "Early-check-out",
    title: "Early check-out",
    content: () => <EarlyCheckOut />,
  },
  {
    path: "Absent-report",
    title: "Absent report",
    content: () => <AbsendReport />,
  },
  {
    path: "myleavereport",
    title: "Leave History",
    content: () => <Myleavereport />,
  },
  {
    path: "released-notes",
    title: "Released Notes",
    content: () => <ReleasedNote />,
  },
  {
    path: "attendance-report-monthly",
    title: "Monthly Attendance Report",
    content: () => <MonthlyAttendanceReport />,
  },
  {
    path: "roles",
    title: "Role",
    content: () => <RoleManagement />,
  },
  {
    path: "shift",
    title: "Shift",
    content: () => <Shift />,
  },
  {
    path: "rolesandpermissions",
    title: "Roles and permissions",
    content: () => <RolesAndPermissions />,
  },
  {
    path: "break",
    title: "Break",
    content: () => <Break />,
  },
  {
    path: "leave-categories",
    title: "Leave Categories",
    content: () => <LeaveCategories />,
  },
  {
    path: "holiday",
    title: "Holiday",
    content: () => <Holiday />,
  },
  {
    path: "close-account",
    title: "Close Account",
    content: () => <CloseAccount />,
  },
  {
    path: "employeedetails/:id",
    title: "employeedetails",
    content: () => <EmployeeDetails />,
  },
  {
    path: "permission/:roleId/:roleName",
    title: "Permission",
    content: () => <Permission />,
  },
  {
    path: "managerdashboard",
    title: "Manager Dashboard",
    content: () => <ManagerDashboard />,
  },
  {
    path: "hrdashboard",
    title: "Hr Dashboard",
    content: () => <HrDashboard />,
  },
  {
    path: "band",
    title: "band",
    content: () => <Band />,
  },
  {
    path: "profile-details/:id",
    title: "Profile Details",
    content: () => <ProfileDetails />,
  },
  {
    path: "policies",
    title: "HR Policy",
    content: () => <HRPolicy />,
  },
  {
    path: "ownerdashboard",
    title: "Dashboard",
    content: () => <Ownerdashboard />,
  },
  {
    path: "appraisal",
    title: "Appraisal",
    content: () => <Appraisal />,
  },
  {
    path: "myappraisal",
    title: "My Appraisal",
    content: () => <MyAppraisal />,
  },
  {
    path: "form-response",
    title: "Appraisal",
    content: () => <AppraisalResponse />,
  },
  {
    path: "add-appraisal",
    title: "Appraisal",
    content: () => <AddAppraisal />,
  },

  {
    path: "formbuilder",
    title: "Form Builder",
    content: () => <FormBuilder />,
  },
  {
    path: "recruitment",
    title: "Recruitment",
    content: () => <Recruitment />,
  },
  {
    path: "onboard",
    title: "OnBoard",
    content: () => <Onboarding />,
  },
  {
    path: "recruitment-tab",
    title: "RecruitmentTab",
    content: () => <RecruitmentTab />,
  },
  {
    path: "contract",
    title: "Contract",
    content: () => <Contract />,
  },
  {
    path: "addjob",
    title: "Addjob",
    content: () => <Addjob />,
  },
  {
    path: "myteam",
    title: "My Team",
    content: () => <MyTeam />,
  },
  {
    path: "contract-template",
    title: "Contract Template",
    content: () => <TemplateContract />,
  },
  {
    path: "issue-contract",
    title: "Issue Contract",
    content: () => <IssueContract />,
  },
  {
    path: "hr-documents",
    title: "Documents",
    content: () => <HRDocuments />,
  },
  {
    path: "/form/:clientId/:id",
    title: "Form",
    content: () => <FormResponse />,
  },
  {
    path: "pending-employee",
    title: "Pending Employee",
    content: () => <PendingEmployee />,
  },
  {
    path: "companypolicy",
    title: "Company Policy",
    content: () => <CompanyPolicy />,
  },
  {
    path: "add-client",
    title: "Client Add New",
    content: () => <AddNewClient />,
  },
  {
    path: "edit-client/:clientId",
    title: "Client Add Edit",
    content: () => <AddNewClient />,
  },
  // {
  // path: "client-details/:id/markaspaid",
  // title: "Mark as Paid",
  // content: () => <MarkAsPaidPage />,
  // },
  {
    path: "client-details/:id/send-survey",
    title: "Client Survey",
    content: () => <SendFundRequestMail />,
  },
  {
    path: "client-details/:id/markaspaid",
    title: "Mark as Paid",
    content: () => <MarkAsPaidPage />,
  },
  {
    path: "client-details/:id",
    title: "Client detail",
    content: () => <ClientDetails />,
  },
  {
    path: "client",
    title: "ClientNew",
    content: () => <ClientNew />,
  },
  {
    path: "engagement/:id/add-resources",
    title: "Add Resources",
    content: () => <AddResources />,
  },
  {
    path: "engagement/:id/claims",
    title: "Claims",
    content: () => <Claims />,
  },
  {
    path: "engagement/:id/todo/:todoId",
    title: "Todo View",
    content: () => <TodoView />,
  },
  {
    path: "engagement/:id/financialsummary",
    title: "Financial Summary",
    content: () => <FinancialSummary />,
  },
  {
    path: "engagement/:id/engagementappraisal/:resourceid",
    title: "Financial Summary",
    content: () => <EngagementAppraisal />,
  },
  {
    path: "engagement/:id",
    title: "Engagement",
    content: () => <EngagementView />,
  },
  {
    path: "engagement",
    title: "Engagement",
    // content: () => <Engagement />,
    content: () => <EngagementCheckNew />,
  },
  {
    path: "add-engagement",
    title: "Add Engagement",
    content: () => <AddNewEngagement />,
  },
  {
    path: "timesheet",
    title: "Timesheet",
    content: () => <TimeSheet />,
  },
  {
    path: "timesheet-detailed/:week/:employeeId/:timesheetId/:status",
    title: "Timesheet Detailed",
    content: () => <TimeSheetDetailed />,
  },
  {
    path: "resource-planning",
    title: "Resource Planning",
    content: () => <ResourcePlanning />,
  },
  {
    path: "performance",
    title: "Performance",
    content: () => <Performance />,
  },
  {
    path: "assets",
    title: "Assets",
    content: () => <Assests />,
  },
  {
    path: "clientcontact",
    title: "Client Contact",
    content: () => <ClientContact />,
  },
  {
    path: "client-contact-details/:id",
    title: "Client Contact Details",
    content: () => <ClientContactDetails />,
  },
  {
    path: "Chargeout-rates",
    title: "Chargeout Rates",
    content: () => <ChargeoutRates />,
  },
  {
    path: "jobdescription",
    title: "jobdescription",
    content: () => <JobDescription />,
  },
  {
    path: "matterLookUpCalendar",
    title: "Client Contact Details",
    content: () => <EngagementCalendar />,
  },
  {
    path: "mydeclaration",
    title: "My Declaration",
    content: () => <MyDeclaration />,
  },
  {
    path: "independence-analysis/:id",
    title: "Independence Analysis",
    content: () => <DetailView />,
  },
  {
    path: "independence-analysis",
    title: "Independence Analysis",
    content: () => <IndependenceAnalysis />,
  },
  {
    path: "weekcalendar",
    title: "Week Calendar",
    content: () => <WeekCalendarView />,
  },
  {
    path: "timesheet-reports",
    title: "Timesheet Reports",
    content: () => <TimesheetReport />,
  },
  {
    path: "onboarding-reports",
    title: "Onboarding Reports",
    content: () => <OnboardingReport />,
  },
  {
    path: "viewdetails/:id",
    title: "Viewdetails",
    content: () => <ViewDetails />,
  },
  {
    path: "viewmytabledata/:contactId",
    title: "Viewmytabledata",
    content: () => <Viewmytabledata />,
  },
  {
    path: "evaluation",
    title: "Evaluation",
    content: () => <Evaluation />,
  },
  {
    path: "nextAppraisal",
    title: "NextAppraisal",
    content: () => <NextAppraisal />,
  },
  {
    path: "roleaccountant",
    title: "roleaccountant",
    content: () => <RoleAccountant />,
  },
  {
    path: "performancemanagement",
    title: "Performance Management",
    content: () => <PerformanceManagement />,
  },
  {
    path: "MinePerformance",
    title: "Mine Performance",
    content: () => <MinePerformance />,
  },
  {
    path: "MyTeamPerformance",
    title: "MyTeam Performance",
    content: () => <MyTeamPerformance />,
  },
  {
    path: "PerformanceContract",
    title: "Performance Contract",
    content: () => <PerformanceContract />,
  },
  {
    path: "CreatingPerformance",
    title: "Creating Performance",
    content: () => <CreatingPerformance />,
  },
  {
    path: "reviewagree/:id",
    title: "Review Agree",
    content: () => <ReviewAgree />,
  },
  {
    path: "Agreed",
    title: "Agreed",
    content: () => <Agreed />,
  },
  {
    path: "attend/:id",
    title: "Attend",
    content: () => <Attend />,
  },
  {
    path: "view/:id",
    title: "View Pending",
    content: () => <Viewpending />,
  },
  {
    path: "viewcompleted/:id",
    title: "View Completed",
    content: () => <Viewcompleted />,
  },
  {
    path: "evaluatedresponse/:id",
    title: "Evaluated Response",
    content: () => <EvaluatedResponse />,
  },
  {
    path: "Evaluated",
    title: "Evaluated",
    content: () => <Evaluated />,
  },
  {
    path: "EditingAppraisal",
    title: "Editing Appraisal",
    content: () => <EditingAppraisal />,
  },
  {
    path: "changemanager",
    title: "Change Manager",
    content: () => <ChangeManager />,
  },
  {
    path: "awaitngresponse/:id",
    title: "awaitng Response",
    content: () => <AwaitingAppraiseeRespons />,
  },
  {
    path: "viewcontract/:id",
    title: "view Contract",
    content: () => <ViewContract />,
  },
  {
    path: "currency",
    title: "view Currency",
    content: () => <CurrencyCreate />,
  },
  {
    path: "announcement",
    title: "Announcement",
    content: () => <Announcement />,
    permission: [],
  },
  {
    path: "add-edit-announcement",
    title: "AddAnnouncement",
    content: () => <AddEditAnnouncement />,
    permission: [],
  },
  {
    path: "announcement-details/:id",
    title: "Announcement Details",
    content: () => <AnnouncementDetails />,
    permission: [],
  },
  {
    path: "accounts",
    title: "Accounts",
    content: () => <Accounts />,
  },
  {
    path: "client-new",
    title: "addnewclient",
    content: () => <AddEditClient />,
  },
  {
    path: "client-detail/:id/addbills",
    title: "Client",
    content: () => <AddNewBilling />,
  },
  {
    path: "client-detail/:id",
    title: "clientdetail",
    content: () => <ClientDetail />,
  },
  {
    path: "pending-client",
    title: "addnewclient",
    content: () => <PendingClient />,
  },
  {
    path: "matter",
    title: "matter",
    content: () => <Matter />,
  },
  {
    path: "create-matter/add-resources",
    title: "add-resources-for-matter",
    content: () => <AddResourceForMatter />,
  },
  {
    path: "create-matter",
    title: "create-matter",
    content: () => <Creatematter />,
  },
  {
    path: "create-matter/:id",
    title: "create-matter",
    content: () => <Creatematter />,
  },
  {
    path: "matter-details/:id/financialSummaryMatter",
    title: "financial-summary-matter",
    content: () => <FinancialSummaryMatter />,
  },
  {
    path: "matter-details/:id/billing",
    title: "Billing",
    content: () => <Billing />,
  },
  {
    path: "matter-details/:id/addbills",
    title: "Billing",
    content: () => <AddNewBilling />,
  },
  {
    path: "matter-details/:id/clientSurveyMatter",   // ← add this
    title: "client-survey-matter",
    content: () => <ClientSurveyMatter />,
  },
  {
    path: "matter-details/:id/billingemail",   // ← add this
    title: "billing-email",
    content: () => <BillingEmail />,
  },
  {
    path: "matter-details/:id/markaspaid",
    title: "matter-details",
    content: () => <MarkAsPaidPage />,
  },
  {
    path: "matter-details/:id",
    title: "matter-details",
    content: () => <MatterDetails />,
  },

  {
    path: "details",
    title: "mytask",
    content: () => <MyTask />,
  },
  {
    path: "billingentity",
    title: "Billing Entity",
    content: () => <BillingEntity />,
  },
  {
    path: "myincident",
    title: "incident",
    content: () => <MyIncident />,
  },
  // {
  //   path: "mydisciplinary",
  //   title: "My Disciplinary",
  //   content: () => <HrMyDisciplinary />,
  // },
  {
    path: "viewincident",
    title: "View Incident",
    content: () => <ViewIncident />,
  },
  {
    path: "categoryview",
    title: "Category View",
    content: () => <CategoryView />,
  },
  {
    path: "categorytable",
    title: "Category Table",
    content: () => <CategoryTable />,
  },
  {
    path: "ViewUnderReview",
    title: "View Under Review",
    content: () => <ViewUnderReview />,
  },
  {
    path: "ViewResolved",
    title: "View Resolved",
    content: () => <ViewResolved />,
  },
  {
    path: "ViewDismissed",
    title: "View Dismissed",
    content: () => <ViewDismissed />,
  },
  {
    path: "EditDeletepage",
    title: "Edit Delete page",
    content: () => <EditDeletepage />,
  },
  {
    path: "viewincidentlog",
    title: "View Incident Log",
    content: () => <Viewincidentlog />,
  },
  {
    path: "disciplinary",
    title: "Disciplinary",
    content: () => <HrMyDisciplinary />,
  },
  {
    path: "viewdisciplinary/:id",
    title: "Disciplinary",
    content: () => <Viewdisciplinary />,
  },
  {
    path: "disciplinary-details",
    title: "View Detail",
    content: () => <ViewDetailsDisciplinary />,
  }, {
    path: "mydisciplinary",
    title: "My Disciplinary",
    content: () => <HomeDisciplinary />,
  },

  {
    path: "incidentlog",
    title: "Incident Log",
    content: () => <IncidentLog />,
  },

];

export default Routes;